module.exports = __webpack_public_path__ + "components/resort-guide/static/icon-beginner--black-6b69356c85cc1ee327c31dad4d9628ae.svg";